import React, { useMemo } from 'react';
import get from 'lodash/get';
import { format } from 'd3-format';
import { sum, range } from 'd3-array';
import Warning from './Warning';
import Table from './Table';
import union from '@turf/union';
import { FarmContext, GEO_URL } from './FarmContext';
import { getArea } from './geo';


export default function CropHistory() {
  const { boundary } = React.useContext(FarmContext);
  const [cdlLayer, setCdlLayer] = React.useState({});


  const years = useMemo(() => {
    const year = new Date().getFullYear();
    return range(year - 6 , year).reverse();
  }, []);

  React.useEffect(() => {
    if (boundary.features.length === 0) return;
    const combined = boundary.features.reduce((acc, cur) => {
      return union(acc, cur);
    });
    years.forEach(year => {
        fetch(GEO_URL + '/geoserver/cdl_image', {
          method: 'POST',
          body: JSON.stringify({boundary: combined, year: year}),
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          }
        })
          .then(r => r.json())
          .then(r => setCdlLayer(otherYears => ({...otherYears, [year]: r})))
    });

  }, [boundary, years]);


  if (boundary.features.length === 0) return <Warning text="No farm boundary, go and draw one on the farm map." />
  console.log(cdlLayer)
  const cdlLayerAgg = cdlLayer;

  if (Object.values(cdlLayerAgg).length === 0) return <div> 
      <h2 className="text-xl">Loading...</h2> 
  </div>

  const allCropsDup = [].concat(...Object.values(cdlLayerAgg).map(y => y._legend.map(l => l.name)));
  const allCrops = Array.from(new Set(allCropsDup));

  const toNameToAcres = (leg, fmt = x => x) => leg.reduce((acc, cur) => {
    return {...acc, [cur.name]: fmt(cur.acres)}
  }, {});

  const recentYearAcres = toNameToAcres(get(cdlLayerAgg, [years[0], '_legend'], []))
  allCrops.sort((a, b) => get(recentYearAcres, b, 0) - get(recentYearAcres, a, 0));


  const rows =  years.map(year => {
      if (!cdlLayerAgg[year]) return { year };
      return {
        year,
        img: <img alt="CDL" className="h-24 w-auto max-w-none" src={cdlLayerAgg[year].source.url} />,
        ...toNameToAcres(cdlLayerAgg[year]._legend, format('.0f'))
      }
  })
  const headers = ['year', 'img'].concat(allCrops);


  return <div>
    <h2 className="text-xl">
      Historical Crop Acres - <a target="_blank" href="https://www.nass.usda.gov/Research_and_Science/Cropland/docs/US_2020_CDL_legend.jpg" rel="noreferrer" > click here for Color Legend </a>
    </h2>
    <h3>
      Boundary: {format('.0f')(sum(boundary.features, f => getArea(f.geometry)))} acres
    </h3>
    <Table
      headers={headers}
      rows={rows}
    />
  </div>

}